var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-expand-md navbar-dark d-flex justify-content-between"},[(_vm.payeeId)?_c('div',{staticClass:"company-name"},[_vm._v(" "+_vm._s(_vm.payee ? _vm.payee.name : '')+" ")]):_c('div'),_c('div',{staticClass:"d-flex navbar-icon align-items-center"},[_c('NavbarDropdown',{staticClass:"ml-auto mr-2 navbar-icon"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }